"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _consts = require("./../consts.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.span.withConfig({
  displayName: "OzCopyable__Wrapper",
  componentId: "sc-1oe4dov-0"
})(["\n  border-bottom: 2px solid ", ";\n  color: ", ";\n  position: relative;\n  cursor: pointer;\n"], _consts.SPANISHGREY, _consts.SPANISHGREY);

var Tip = _styledComponents.default.div.withConfig({
  displayName: "OzCopyable__Tip",
  componentId: "sc-1oe4dov-1"
})(["\n  display: ", ";\n  position: absolute;\n  bottom: -35px;\n  right: -2px;\n  text-align: center;\n  z-index: 999;\n\n  border-radius: 8px;\n  padding: 5px 15px;\n  background-color: ", ";\n  box-shadow: 0px 2px 16px #20283362;\n  color: #fff;\n\n  &::after{\n    display: block;\n    content: \"\";\n    position: absolute;\n    top: -5px;\n    right: 20px;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    \n    border-bottom: 5px solid ", ";\n  }\n"], function (props) {
  return props.show ? "block" : "none";
}, _consts.CHARCOAL, _consts.CHARCOAL);

var OzCopyable = function OzCopyable(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(false),
      showTip = _useState[0],
      setShowTip = _useState[1];

  return __jsx(Wrapper, {
    onClick: function onClick() {
      navigator.clipboard.writeText(children);
      setShowTip(true);
      setTimeout(function () {
        setShowTip(false);
      }, 3000);
    }
  }, children, __jsx(Tip, {
    show: showTip
  }, "Copied!"));
};

var _default = OzCopyable;
exports.default = _default;